import React, { useState, useMemo, useEffect } from 'react';
import styles from './PreviewDyncGroup.module.scss';
import { getIn18Text } from 'api';
import { Button, Modal } from '@lingxi-common-component/sirius-ui';
import { MailActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import dayjs from 'dayjs';
const PreviewDyncGroup = props => {
    var _a;
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const dyncGroupSendPreview = useAppSelector(state => state.mailReducer.dyncGroupSendPreview);
    const dispatch = useAppDispatch();
    const [sendTime, setSendTime] = useState('');
    const cont = useMemo(() => {
        const { entry: { content: { content }, }, } = currentMail;
        const mailCont = content || '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(mailCont, 'text/html');
        const varEles = doc.querySelectorAll('.mce-lx-var');
        varEles.forEach(item => {
            try {
                const dataVar = item.getAttribute('data-var');
                const execRes = /#{wmt_crm_(.+?)}/.exec(dataVar || '');
                const dataVarShow = item.innerText;
                const execRes1 = /\[(.+?)\]/.exec(dataVarShow || '');
                if ((execRes === null || execRes === void 0 ? void 0 : execRes.length) && (execRes1 === null || execRes1 === void 0 ? void 0 : execRes1.length)) {
                    const str = execRes[1];
                    const str1 = execRes1[1];
                    if (str && str1) {
                        if (str === str1) {
                            item.remove();
                        }
                        else {
                            item.replaceWith(str1);
                        }
                    }
                }
            }
            catch (err) {
                console.log('替换失败', err);
            }
        });
        const innerStr = doc.documentElement.innerHTML;
        return innerStr;
    }, [currentMail]);
    const getEmailStr = (arr) => {
        var _a;
        return ((_a = arr[0].contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) || '';
    };
    const receivers = useMemo(() => {
        return getEmailStr((currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) || []);
    }, [currentMail]);
    const receiverNum = useMemo(() => {
        return ((currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) || []).length;
    }, [currentMail]);
    const sender = useMemo(() => {
        if (!(currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender))
            return '';
        return getEmailStr([currentMail.sender]);
    }, [currentMail]);
    const clearDyncGroupSendPreview = () => {
        dispatch(MailActions.doChangeDyncGroupSendPreview({ show: false, finishFun: null }));
    };
    const cancel = () => {
        clearDyncGroupSendPreview();
    };
    const back = () => {
        clearDyncGroupSendPreview();
    };
    const toSend = () => {
        const { finishFun } = dyncGroupSendPreview;
        finishFun && finishFun();
        clearDyncGroupSendPreview();
    };
    useEffect(() => {
        console.log('currentMailcurrentMail', currentMail);
    }, [currentMail]);
    useEffect(() => {
        const timeStr = dayjs().format('YYYY年MM月DD日HH时mm分');
        setSendTime(timeStr);
    }, []);
    return (React.createElement(Modal, { title: getIn18Text('YULAN'), wrapClassName: styles.previewWrap, className: styles.previewDyncGroupModal, width: 550, visible: true, destroyOnClose: true, onCancel: cancel, footer: null },
        React.createElement("div", { className: styles.previewDyncGroup },
            React.createElement("p", { className: styles.intro }, getIn18Text('TISHIGONGWSJRCCJZSDY12', { receiverNum })),
            React.createElement("p", { className: styles.title }, (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.title),
            React.createElement("div", { className: styles.mailInfo },
                React.createElement("p", null,
                    getIn18Text('receiver-task'),
                    "\uFF1A",
                    receivers),
                React.createElement("p", null,
                    getIn18Text('SHIJIAN'),
                    "\uFF1A",
                    sendTime),
                React.createElement("p", null,
                    getIn18Text('sender-task'),
                    "\uFF1A",
                    sender)),
            React.createElement("iframe", { className: styles.cont, srcDoc: cont }),
            React.createElement("div", { className: styles.footer },
                React.createElement(Button, { onClick: back }, getIn18Text('FANHUI')),
                React.createElement(Button, { className: styles.blueBtn, onClick: toSend }, getIn18Text('KAISHIFASONG'))))));
};
export default PreviewDyncGroup;
